<template>
  <div class="designer-base">
    <div class="left-column">
      <div class="logo">
        <img
          src="~@/assets/logo.svg"
          alt="Five Star"
        >
      </div>
      <designer-menu :menu-items="menuItems"/>
    </div>
    <div class="center-column">
      <div class="top-bar">
        <el-row type="flex">
          <el-col>
            <h1>{{ evaluation.name }}</h1>
            <h2>{{ evaluation.division }}</h2>
          </el-col>
          <el-col class="text-right">
            <el-dropdown trigger="click">
              <el-button class="el-dropdown-link">
                <i class="icon-more_vert"/>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <span @click="onSave"><i class="icon-save"/> Guardar</span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span @click="onExit"><i class="icon-exit"/> Salir</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </div>
      <designer-content
        :template="evaluation.template"
        @update:selectedItem="onUpdateSelected"
      />
    </div>
    <div class="right-column">
      <designer-panel
        :branch-types="evaluation.dealerTypes"
        :item="selectedItem"
      />
    </div>
  </div>
</template>

<script>
import DesignerContent from './designer-content'
import DesignerMenu from './designer-menu'
import menuItems from './api/menu-items'
import DesignerPanel from './designer-panel'

export default {
  name: 'DesignerBase',
  components: { DesignerPanel, DesignerContent, DesignerMenu },
  props: {
    branchTypes: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    evaluation: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      menuItems: menuItems,
      selectedItem: {}
    }
  },
  computed: {},
  methods: {
    onUpdateSelected (item) {
      if (this.selectedItem.$id === item.$id) {
        return
      }
      this.$set(this.selectedItem, '$selected', false)
      this.selectedItem = item
      this.$set(this.selectedItem, '$selected', true)
    },
    onSave () {
      this.$set(this.selectedItem, '$selected', false)
      console.log(this.selectedItem)
      this.selectedItem = {}
      this.$emit('save')
    },
    onExit () {
      this.$confirm('¿Está seguro que desea salir?').then(() => {
        this.$emit('cancel')
      })
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
$border-color: #e0e0e0;
.designer-base {
  display: flex;
  width: 100%;
  .left-column {
    background-color: #fff;
    height: 100vh;
    min-width: 200px;
    border-right: 1px solid $border-color;
    .logo {
      padding: 30px;
      text-align: center;
      img {
        width: 90px;
      }
    }
  }
  .center-column {
    .top-bar {
      padding: 20px;
      background-color: #fff;
      border-bottom: 1px solid $border-color;
      h1 {
        font-size: 18px;
        margin: 0;
      }
      h2 {
        font-size: 12px;
        margin: 0;
      }
    }
    flex: 1 1 auto;
    overflow: auto;
  }
  .right-column {
    min-width: 380px;
    width: 25vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/designer/designer-base.vue